import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row no-wrap restriction-config" }

import SInput from 'SharedComponents/ui/Input/SInput.vue';
import SSelect from 'SharedComponents/ui/Select/SSelect.vue';
import useValidation from 'SharedDir/common/composables/useValidation';
import { IDateRestriction } from 'SharedDir/declarations/fields';
import { DateDirection, DaysMode } from 'SharedDir/constants/field-types';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'DateRestriction' },
  __name: 'DateRestriction',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const blankInnerValue = () => ({
  days: null,
  daysMode: DaysMode.all,
  direction: DateDirection.before,
});

const props = __props;
const emit = __emit;
const { innerValue, emitValue } = useValue<null | IDateRestriction, IDateRestriction>(props, emit, {
  transform: (v) => v || blankInnerValue(),
  mrofsnart: (iv) => (iv.days === null ? null : iv),
});
const { IsInteger, GreaterThen, LessThenOrEqual } = useValidation();

const dayModes = [
  { value: DaysMode.all, label: 'Календарные дни' },
  { value: DaysMode.workdays, label: 'Рабочие дни' },
];

const dateDirections = [
  { value: DateDirection.before, label: 'До' },
  { value: DateDirection.after, label: 'После' },
];

return (_ctx: any,_cache: any) => {
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!

  return (_openBlock(), _createBlock(SInput, {
    modelValue: _unref(innerValue).days,
    "onUpdate:modelValue": [
      _cache[2] || (_cache[2] = ($event: any) => ((_unref(innerValue).days) = $event)),
      _unref(emitValue)
    ],
    modelModifiers: { number: true },
    class: "date-restriction",
    type: "number",
    clearable: "",
    outlined: "",
    dense: "",
    "hide-bottom-space": "",
    rules: [_unref(IsInteger)(), _unref(GreaterThen)(0), _unref(LessThenOrEqual)(1000)]
  }, {
    after: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SSelect, {
          modelValue: _unref(innerValue).daysMode,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_unref(innerValue).daysMode) = $event)),
            _unref(emitValue)
          ],
          dense: "",
          borderless: "",
          options: dayModes,
          "emit-value": "",
          "map-options": ""
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_q_btn_toggle, {
          modelValue: _unref(innerValue).direction,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).direction) = $event)),
            _unref(emitValue)
          ],
          class: "q-field__control",
          "no-caps": "",
          unelevated: "",
          border: "",
          options: dateDirections
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "rules", "onUpdate:modelValue"]))
}
}

})